export const STORAGE_KEYS = {
  patientFormPSFilters: 'lh_patient:PS+Filter',
  authentication: 'lh:patient:is-authenticated',
};
